import constants from './constants';

const isPhotoSeriesShared = (photoSeries, customer) => photoSeries
         && customer
         && photoSeries.sharedWithCustomerIds
         && photoSeries.sharedWithCustomerIds.includes(customer.id);

const getVinErrorMessage = (error) => constants.VIN_ERROR[error] || error;

export default {
  isPhotoSeriesShared,
  getVinErrorMessage,
};
